<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-input v-model="page.repositoryName" class="ipt-sty w70f" placeholder="请输入算法名称"></el-input
        ></el-col>
        <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加算法</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="repositoryName" label="算法名称" header-align="center" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="repositoryTypeName" label="算法类型" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="repositoryUse" label="算法用途" header-align="center" align="center" show-overflow-tooltip> 
        </el-table-column>
        <el-table-column prop="repositoryDescription" label="算法说明" header-align="center" align="center" show-overflow-tooltip> 
        </el-table-column>
        <!-- <el-table-column prop="createTime" label="前置条件" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column> -->
        <el-table-column prop="state" label="状态" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.state == 'Y'?'有效':'停用' }}</template>
        </el-table-column> 
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column> 
        <el-table-column prop="updateTime" label="上次更新时间" sortable header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="算法名称:" prop="repositoryName">
          <el-input v-model="ruleForm.repositoryName" autocomplete="off" class="w100f" placeholder="请输入算法名称"></el-input>
        </el-form-item>
        <el-form-item label="算法类型:" prop="repositoryType">
          <el-select v-model="ruleForm.repositoryType" placeholder="请选择" class="w100f">
            <el-option
              v-for="item in repositoryTypeList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="算法用途:" prop="repositoryUse">
          <el-input v-model="ruleForm.repositoryUse" autocomplete="off" class="w100f" placeholder="请输入算法用途"></el-input>
        </el-form-item>
        <el-form-item label="算法说明:" prop="repositoryDescription">
          <el-input type="textarea" v-model="ruleForm.repositoryDescription" placeholder="请输入算法说明"></el-input>
        </el-form-item>
        <!-- <el-form-item label="显示顺序:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.state" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.state" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '添加算法'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        repositoryName: '',
        repositoryType: '', 
        repositoryUse: '',
        state:'Y',
        repositoryDescription:''
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        repositoryName: '', 
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '', 
        code: '',
        name:'',
        parameterValue:'',
      },
      tableData: [],
      rules: {
          repositoryName: [
            { required: true, message: '请输入算法名称', trigger: 'blur' },
            { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
          ], 
          repositoryType: [
            { required: true, message: '请输入算法类型', trigger: 'change' }
          ],
          repositoryUse: [
            { required: true, message: '请输入算法用途', trigger: 'change' }
          ],
          repositoryDescription: [
            { required: true, message: '请输入算法说明', trigger: 'blur' }, 
          ],
      },
      multipleSelection: [],
      repositoryTypeList:[],
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getrepositoryTypeList();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        repositoryName: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getrepositoryTypeList() {
      let self = this;
      self.dto.tenantGuid = self.$store.getters.getTenantGuid;
      self.dto.code = 'SFLX';
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sysparameter/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryTypeList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除算法成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '添加算法';
        self.ruleForm.repositoryName = '';
        self.ruleForm.repositoryType = '';
        self.ruleForm.repositoryUse = '',
        self.ruleForm.bizState = 'Y';
      } else {
        self.textTitle = '编辑算法';
        self.ruleForm.guid = row.guid; 
        self.ruleForm.repositoryName = row.repositoryName;
        self.ruleForm.repositoryType = row.repositoryType;
        self.ruleForm.repositoryUse = row.repositoryUse;
        self.ruleForm.bizState = row.bizState;
        self.ruleForm.repositoryDescription = row.repositoryDescription;
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = { 
            repositoryName: self.ruleForm.repositoryName,
            repositoryType: self.ruleForm.repositoryType,
            repositoryUse: self.ruleForm.repositoryUse,
            repositoryDescription: self.ruleForm.repositoryDescription,
            state: self.ruleForm.state,
          };
          self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加算法成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            repositoryName: self.ruleForm.repositoryName,
            repositoryType: self.ruleForm.repositoryType,
            repositoryUse: self.ruleForm.repositoryUse,
            repositoryDescription: self.ruleForm.repositoryDescription,
            state: self.ruleForm.state,
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/math-repository/data/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑算法成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
